export enum NotificationDeliveryType {
     None = 0,
     Email = 1,
     SignalR = 2,
     // Future Notification Delivery Types should be bitwise enums. Ask Chris
}